// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3iWMK","rootSmall":"AddTileButton_rootSmall__25BhT"};